<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib.js";

    const actions = [
        "Create",
        "Edit",
        "Delete",
        'Register'
    ];

    export let memberId = null;

    let changeLog = null;
    let viewAll = false;

    export const initialize = () => {
        if (memberId && memberId > 0 && !changeLog) {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            changeLog = result;
        }

        const onFailure = err => {
        };

        R.handle(R.member.log, memberId, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

{#if changeLog}
    {#if changeLog.length}
        <table class="table table-list table-sm">
            <thead>
            <tr>
                <th>DATE</th>
                <th>ACTION</th>
                <th>USER</th>
            </tr>
            </thead>
            <tbody>
            {#each changeLog as item, index}
                {#if viewAll || index < 10}
                    <tr>
                        <td class="datetime-column">{ formatDate(item.created_at, 'd-m-y H:i') }</td>
                        <td>{ actions[item.action_id - 1] }</td>
                        <td>
                            {#if item.user}
                                { item.user.name }
                            {/if}
                        </td>
                    </tr>
                {/if}
            {/each}
            </tbody>
        </table>
        {#if changeLog.length > 10}
            <div class="text-center">
                {#if !viewAll}
                    <button class="btn btn-link" on:click={ () => {viewAll = true} }>view all actions</button>
                {:else}
                    <button class="btn btn-link" on:click={ () => {viewAll = false} }>view less actions</button>
                {/if}
            </div>
        {/if}
    {:else}
        No change log yet!
    {/if}
{/if}